module.exports = __webpack_public_path__ + "logos/logo-quill.bcb021.svg";